import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { BaseTimedProject } from 'tdc-web-backend/timed-projects/schemas';
import { Divider, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import StatusChipField from '../../../../../../components/StatusChipField/StatusChipField';
import DashboardCard from '../../../../../../components/dashboard-card/EndToEndCard.tsx/DashboardCard';
import { primaryDark } from '../../../../../../utils/color';
import CustomTable from '../../../../../../components/custom-table/CustomTable';
import { formatDateFns } from '../../../../../../utils/helpers';
import useAuth from '../../../../../../utils/hooks/useAuth';

const MyPitches = () => {
  const { t, i18n } = useTranslation();
  const {
    authData: { userData },
  } = useAuth();
  const columns: GridColDef[] = [
    {
      field: 'projectName',
      headerName: t('tenders.projectName'),
      flex: 0.4,
      renderCell: (params: GridRenderCellParams) => (
        <Typography variant="body2" sx={{ color: 'primaryDark.600' }}>
          {params.value}
        </Typography>
      ),
    },
    {
      field: 'published',
      headerName: t('common.published'),
      flex: 0.4,
      renderCell: (params: GridRenderCellParams) => (
        <Typography variant="body1" sx={{ color: 'primaryDark.600' }}>
          {formatDateFns(params.value, i18n.language)}
        </Typography>
      ),
    },
    {
      field: 'status',
      headerName: t('common.status'),
      flex: 0.2,
      renderCell: (params: GridRenderCellParams) => <StatusChipField text={params.value} />,
    },
  ];

  return (
    <DashboardCard
      headline={t('homescreen.myLatestPitches')}
      linkText={t('common.viewAll')}
      link="/dashboard/pitches"
      renderComponent={
        <>
          <Divider
            sx={{ width: '100%', my: 0, backgroundColor: primaryDark[250] }}
            color="primaryDark.500"
          />
          <CustomTable<BaseTimedProject>
            sx={{
              '&.MuiDataGrid-root .MuiDataGrid-cell': {
                padding: '0px',
              },
            }}
            resource="timed-project-pitches"
            disableTabView
            columns={columns}
            searchParams={{
              limit: 4,
              orderBy: '-published',
              company: userData?.membership?.company,
            }}
            autoHeight
            hideFooter
          />
        </>
      }
    />
  );
};

export default MyPitches;
